import { css } from "styled-components";

export type CollapsableProps = {
  collapse?: "lg" | "md" | "sm";
};

const collapsable = css<CollapsableProps>`
  @media screen and (max-width: 1200px) {
    display: ${({ collapse }) => (collapse === "md" ? "none" : "")};
  }

  @media screen and (max-width: 768px) {
    display: ${({ collapse }) => (collapse === "sm" ? "none" : "")};
  }
`;

export default collapsable;
